// extracted by css-extract-rspack-plugin
module.exports =  {"warning":"BulkStatusUpdateModal__warning--flZge","modalBody":"BulkStatusUpdateModal__modalBody--uBuSq","annotation":"BulkStatusUpdateModal__annotation--uZIbB"};